import { useEffect } from 'react';

import { cn } from '~/lib/cn';

import { PANEL_CLASS } from './constants';
import type { SlideOutPanelProps } from './types';

export function SlideOutPanel({
  panelRef,
  panelWidth,
  children,
  className,
}: SlideOutPanelProps) {
  // Animate the panel into view after it mounts.
  useEffect(() => {
    if (panelRef.current) {
      panelRef.current.classList.add(PANEL_CLASS.show);
      panelRef.current.style.transform = '';
    }
  }, [panelRef, panelWidth]);

  return (
    <div
      ref={panelRef}
      className={cn(
        'fixed inset-y-0 right-0 flex max-w-full border-l duration-300 ease-out bg-level-02 border-l-emphasis-subtle text-strong-on-dark',
        className,
      )}
      style={{ transform: `translateX(${panelWidth})`, width: panelWidth }}
      role="document"
    >
      {children}
    </div>
  );
}

SlideOutPanel.displayName = 'SlideOutPanel';
